import { render, staticRenderFns } from "./SubHeaderFilters.vue?vue&type=template&id=06cfce04&scoped=true&"
import script from "./SubHeaderFilters.vue?vue&type=script&lang=js&"
export * from "./SubHeaderFilters.vue?vue&type=script&lang=js&"
import style0 from "./SubHeaderFilters.vue?vue&type=style&index=0&id=06cfce04&lang=scss&scoped=true&"
import style1 from "./SubHeaderFilters.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cfce04",
  null
  
)

export default component.exports